import { useState } from 'react';

import { DeleteOutline } from '@mui/icons-material';
import { Box } from '@mui/material';

import CancelablePopup from '@/components/CancelablePopup';
import presets from '@/components/CancelablePopup/presets';
import Typography from '@/components/Typography';
import { NameInput } from '@/features/Dashboard/components/NameInput';
import { SymbolAlias } from '@/features/Dashboard/components/SymbolAlias';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';
import { TabSymbol } from '@/features/Dashboard/form/AppForm/context/types';

export const SymbolContent = ({ symbol, index }: { symbol: TabSymbol; index: number }) => {
  const { updateSymbol, removeSymbol, form, setCanPreview } = useAppForm();
  const type = form.state.values?.type;

  const [isHovered, setIsHovered] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
          pr: 1
        }}
      >
        <Typography size={14}>#{index + 1}</Typography>
        <Typography
          size={14}
          sx={{ width: 100 }}
        >
          <SymbolAlias
            symbol={symbol}
            type={type}
          />
        </Typography>

        <NameInput
          isHovered={isHovered}
          value={symbol.shortTitle}
          onBlur={() => {
            setCanPreview(true);
          }}
          onChange={val => {
            updateSymbol({
              ...symbol,
              shortTitle: val
            });
          }}
          onFocus={() => {
            setCanPreview(false);
          }}
        />
      </Box>
      <Box
        component='button'
        sx={{
          display: 'flex',
          width: '32px',
          height: '32px',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'info.dark',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          opacity: 1,
          ml: 'auto'
        }}
        onClick={() => {
          setIsDelete(true);
        }}
      >
        <DeleteOutline sx={{ fontSize: 16, color: 'text.primary' }} />
      </Box>
      <CancelablePopup
        isOpened={isDelete}
        setIsOpened={setIsDelete}
        onConfirm={() => {
          removeSymbol(symbol);
        }}
        {...presets.removeItem}
      />
    </Box>
  );
};
